<template>
  <div :class="$style.root">
    <CampHero />

    <CampInfo />

    <DumpStickers />

    <CampSlider />

<!--    <CampForm />-->

    <OurHRs />
  </div>
</template>

<script>
const CampHero = () => import('components/CampHero');
const CampSlider = () => import('components/CampSlider');
const CampInfo = () => import('components/CampInfo');
// const CampForm = () => import('components/CampForm');
const DumpStickers = () => import('components/DumpStickers');
const OurHRs = () => import('components/OurHRs');

export default {
  name: 'Camp',
  components: {
    CampHero,
    CampInfo,
    CampSlider,
    // CampForm,
    DumpStickers,
    OurHRs,
  },
};
</script>

<style lang="scss" module>
@import '../styles/variables';

.root .sideButton {
  background: $red;
}
</style>



// WEBPACK FOOTER //
// src/views/Camp.vue